var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isAuthorized
    ? _c("div", { staticClass: "personal-header__item" }, [
        _c(
          "a",
          { staticClass: "personal-header__link", attrs: { href: _vm.link } },
          [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }